import React, { useEffect, useState } from 'react'

import { WrapperContainer, Modal, Wrapper, Button, WrapperButton } from './styles'
import { createModalPortal } from 'utils/createModalPortal'

interface ModalProps {
  open: boolean
  setAnswer(): void
  handleCloseModal(): void
}

const ModalConfirmation: React.FC<ModalProps> = ({ open, setAnswer, handleCloseModal }) => {
  const [openModal, setOpenModal] = useState(false)

  useEffect(() => {
    setOpenModal(open)
  }, [open])

  return createModalPortal(
    <>
      {openModal && (
        <WrapperContainer id="modal" onClick={handleCloseModal}>
          <Modal>
            <Wrapper>
              <div>
                <h2>Tem certeza que deseja excluir esse item?</h2>
              </div>
            </Wrapper>
            <WrapperButton>
              <Button>
                <button type="button" onClick={handleCloseModal}>
                  Cancelar
                </button>
              </Button>
              <Button>
                <button type="button" className="back-button" onClick={() => setAnswer()}>
                  Excluir
                </button>
              </Button>
            </WrapperButton>
          </Modal>
        </WrapperContainer>
      )}
    </>
  )
}

export default ModalConfirmation
